// src/hooks/useAuth.js
import { createContext, useContext, useEffect, useState } from "react";
import {
  loginService,
  logoutService,
  getCurrentUserService,
} from "../services/auth.service";
import { getToken } from "../services/storage.service";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);

  const isAuthenticated = !!user;

  const login = async (credentials) => {
    const loggedInUser = await loginService(credentials);
    setUser(loggedInUser);
    return loggedInUser;
  };

  const logout = async () => {
    await logoutService();
    setUser(null);
  };

  const loadUser = async () => {
    const token = getToken();
    if (!token) {
      setInitializing(false);
      return;
    }
    try {
      const currentUser = await getCurrentUserService();
      setUser(currentUser);
    } catch (e) {
      console.error("Failed to load user", e);
      await logoutService();
      setUser(null);
    } finally {
      setInitializing(false);
    }
  };

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = {
    user,
    isAuthenticated,
    initializing,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return ctx;
};
